import React, {useCallback, useEffect, useState} from 'react';
import { Stack, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CacheService } from "../../../../common/services/cache.service";
import APIService from "../../../../services/api.service";
import axios from "../../../../services/axiosInstance";
import environment from "../../../../environment/environment";
import { useRecoilState } from "recoil";
import { tokenState } from "../../../../atoms/token";

const StatisticsTab = () => {
  const [token] = useRecoilState(tokenState);
  const [stats, setStats] = useState(null);
  const [startDate, setStart] = useState<Dayjs | null>(null);
  const [endDate, setEnd] = useState<Dayjs | null>(null);

  const getStatistics = useCallback(
    (startDate?: Dayjs, endDate?: Dayjs) => {
      const baseUrl = `${environment.statisticsAPI}GetAllStats`;
      const url =
        startDate && endDate
          ? `${baseUrl}?startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format("YYYY-MM-DD")}`
          : baseUrl;

      const apiService = new APIService<any>(axios, new CacheService(), url, token);
      apiService.getAnyAsync().then((res: any) => {
        setStats(res);
      });
    },
    [token]
  );

  useEffect(() => {
    getStatistics();
  }, [getStatistics]);

  useEffect(() => {
    if (startDate && endDate) {
      getStatistics(startDate, endDate);
    }
  }, [startDate, endDate]);

  return (
    <React.Fragment>
      <div className="center margin-bottom">
        <h1>Statstics</h1>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker 
              label="Start Date" 
              value={startDate}
              onChange={(date) => setStart(date)} 
            />

            <DatePicker 
              label="End Date" 
              value={endDate}
              onChange={(date) => setEnd(date)} 
            />
          </LocalizationProvider>
        </Stack>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <h2>Users</h2>
        </Stack>
        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="New Users In Period"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Users"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
          <Stack spacing={2} direction="column">
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="New Mobile Users"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodMobileUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Mobile Users"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalMobileUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>          
        </Stack>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <h2>Searches</h2>
        </Stack>
        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <Stack spacing={2} direction="column">
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="In Period Searches Performed"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodSearches || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Searches Performed"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalSearches || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>

          <Stack spacing={2} direction="column" sx={{marginBottom: 2}}>
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="In Period Search Users"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodSearchUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Search Users"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalNumberOfSearchUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </Stack>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <h2>Documents</h2>
        </Stack>
        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="In Period Metadata"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodMetaData || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Metadata"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalMetaData || 0 }
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />            
          </Stack>

          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="In Period Entire Document"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodEntireDoc || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Entire Document"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalEntireDoc || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </Stack>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <h2>Downloads</h2>
        </Stack>
        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Orders Placed in Period"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodOrders || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Orders"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalOrders || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Number of Documents"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.InPeriodNumberOfDocs || 0 }
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Total Number of Documents"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.TotalNumberOfDocs || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </Stack>

        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <h2>Uploads</h2>
        </Stack>
        <Stack spacing={2} direction="row" sx={{marginBottom: 1}}>
          <Stack spacing={2} direction="column" >
          <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Uploads Received"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.UploadsReceived || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Uploads Rejected"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.UploadsRejected || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
          <Stack spacing={2} direction="column" >
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Uploads Processed"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.UploadsProcessed || 0 }
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />

            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Users who Uploaded"
              // onChange={e => setParkName(e.target.value)}
              value={stats?.UploadUsers || 0}
              sx={{width: 300}}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </Stack>
      </div>
    </React.Fragment>
  );
}

export default StatisticsTab